export default "__VITE_ASSET__BMNW7nA0__";